import store from '@/store'

// 获取用户信息
function getUserInfo() {
  return {
    type: store.getters.getUser.type, // 角色类型  0个人  1企业  2团队  3组织
    isLogin: !!store.state.loginType, // 是否已登录
    isRealName: !!store.state.user.personalAuth, // 是否已实名
  }
}

/**
 * 校验用户权限
 * @param options 指定权限校验规则
 * {
 *   type : 允许访问的用户类型 默认允许全部类型访问 (person 个人, company 企业, team 团队, organization 组织)
 *   login : 是否登录后才能访问 默认为true (true false)
 *   realName : 是否实名认证后才能访问 默认为true (true false)
 * }
 * @returns {boolean} 是否拦截
 */
function permission(options) {
  let {type, login, realName} = options || {}

  if (type) {
    type = type.map(item => ['person', 'company', 'team', 'organization'].findIndex(i => i === item))
  }

  const rule = {
    type: type || [0, 1, 2, 3],
    login: login === undefined ? true : login,
    realName: realName === undefined ? true : realName
  }

  const userInfo = getUserInfo()

  const headOff =
    rule.login && !userInfo.isLogin ||
    rule.realName && !userInfo.isRealName ||
    (!rule.type.includes(Number(userInfo.type)) && userInfo.type !== undefined)

  return {
    headOff, // 是否拦截
    userInfo, // 用户信息
    rule, // 规则
  }
}



export {getUserInfo, permission}